import * as React from 'react';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';
import {
  calculateOscPrice,
  feesSumPerPax,
  calculatePaxFees,
  calculateTotalMarkupPrice,
} from '../../util/priceCalculations';
import AdditionalPriceRow from './AdditionalPriceRow';
import { hasTariffType } from '../../util/booking-type-utils';

interface AdditionalPricesProps {
  retrieveDb: TFF.BookedRetrieve | undefined;
  serviceFeeTotalAmount: number | undefined;
  servicePackageFee: number | undefined;
  isNdcFlightOnlyBooking: boolean | undefined;
  orderDetailsMidoco: TFF.OrderDetails | undefined;
  isTTSBooking: boolean | undefined;
}

const AdditionalPrices: React.FC<AdditionalPricesProps> = ({
  retrieveDb,
  serviceFeeTotalAmount,
  servicePackageFee,
  isNdcFlightOnlyBooking,
  orderDetailsMidoco,
  isTTSBooking,
}) => {
  const intl = useIntl();

  const rebookFee = feesSumPerPax(orderDetailsMidoco?.Fares?.['ALL']?.FeesAndTaxes);
  const passengersInitialFees = calculatePaxFees(orderDetailsMidoco?.Fares);

  const totalMarkupPrice = () => {
    if (hasTariffType(retrieveDb, 'TO') || hasTariffType(retrieveDb, 'CONSO')) {
      return calculateTotalMarkupPrice(retrieveDb);
    }
    return 0;
  };

  const ticketFee = () => {
    if (hasTariffType(retrieveDb, 'PU') || hasTariffType(retrieveDb, 'Nego')) {
      return calculateTotalMarkupPrice(retrieveDb);
    }
    return 0;
  };

  return (
    <>
      {isNdcFlightOnlyBooking ? (
        <AdditionalPriceRow
          text={intl.formatMessage({ id: 'pricingDetails.bookingFee' })}
          value={passengersInitialFees}
        />
      ) : (
        <>
          {isTTSBooking ? (
            <AdditionalPriceRow text={intl.formatMessage({ id: 'pricingDetails.serviceFeeTTS' })} value={ticketFee()} />
          ) : (
            <AdditionalPriceRow
              text={intl.formatMessage({ id: 'pricingDetails.serviceFee' })}
              value={serviceFeeTotalAmount ?? 0}
            />
          )}
        </>
      )}
      {isNdcFlightOnlyBooking && (
        <AdditionalPriceRow text={intl.formatMessage({ id: 'pricingDetails.changeFee' })} value={rebookFee} />
      )}
      {isTTSBooking && (
        <>
          <AdditionalPriceRow
            text={intl.formatMessage({ id: 'pricingDetails.totalMarkup' })}
            value={totalMarkupPrice()}
          />
          <AdditionalPriceRow text={'Operational Service Charge'} value={calculateOscPrice(retrieveDb)} />
        </>
      )}
      {!isTTSBooking && (
        <AdditionalPriceRow
          text={intl.formatMessage({ id: 'pricingDetails.servicePackagesFee' })}
          value={servicePackageFee ?? 0}
        />
      )}
    </>
  );
};

export default AdditionalPrices;
